import Appearance from '../../pages/Appearance';

import { uuid } from '../../utils/helper';

export default [
  {
    name: 'Appearance',
    link: '/appearance',
    component: Appearance,
    secondaryLinks: [
      '/appearance/pages',
      '/appearance/create-page',
      '/appearance/edit-page',

      '/appearance/blog',
      '/appearance/create-blog',
      '/appearance/edit-blog',

      '/appearance/languages',
      '/appearance/language-edit',

      '/appearance/themes',
      '/appearance/theme-preview',
      '/appearance/file-edit',

      '/appearance/menu',

      '/appearance/files',
    ],
    id: uuid(),
    exact: false,
    react: true,
  },
];
